import React, {Component} from "react";
import {connect} from "react-redux";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import Container from "../../../../../modules/commons/Container";
import {fetchDataAsync} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import {mapToObjectDDL} from "../../../../common/mapper";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import VariantSalesReport from "./variantSalesReport";

class TLReportByVariant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataCabang: [],
            kodeCabang: [],
            search: null,
        };
    };

    componentDidMount = async () => {
        await this.fetchDataCabang();
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        try {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
                menuName: "Dashboard Level Team Leader - Laporan Jual Varian",
                setError: this.props.setError,
            });
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                        search: filteredData[0]?.kodeCabang
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}));
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleSearch = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: this.state.kodeCabang?.value,
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{gap: "20px", alignItems: "center"}}>
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-350px"
                            placeholder="Nama Cabang"
                            isClearable
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleButton
                            styles={{marginBottom: "15px"}}
                            onClick={this.handleSearch}
                        >Cari</SimpleButton>
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>Laporan Jualan Per Varian</Tab>
                            <Tab>Laporan Jualan Per Varian YTD</Tab>
                        </TabList>
                        <TabPanel>
                            <VariantSalesReport
                                {...this.props}
                                tab="variant"
                                search={this.state.search}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <VariantSalesReport
                                {...this.props}
                                tab="ytd"
                                search={this.state.search}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TLReportByVariant);